module.exports = __webpack_public_path__ + "023b31e91db1f3ed6ba6184b3117b001.png";